export default [
  {
    path: '/x1',
    name: 'home',
    component: () => import(/* webpackChunkName: "home" */ './Home')
  }
]
